// Risks and challenges section configuration
// Defines fields for current challenges, risks, and scaling barriers
import { z } from 'zod';
import type { SectionConfig } from '../../types/sections';

// Validation schema for risks section
export const risksSectionSchema = z.object({
  currentChallenges: z.string().min(1, 'Este campo es requerido'),
  modelMarketRisks: z.string().min(1, 'Este campo es requerido'),
  scalingBarriers: z.string().optional(),
});

export type RisksSectionData = z.infer<typeof risksSectionSchema>;

// Section config
export const risksSection: SectionConfig = {
  id: 'risks',
  titleKey: 'Riesgos y desafíos',
  descriptionKey: 'Desafíos actuales y riesgos identificados',
  validationSchema: risksSectionSchema,
  fields: [
    {
      name: 'currentChallenges',
      type: 'textarea',
      label: 'Principales desafíos actuales.',
      placeholder: 'Describe los principales desafíos que enfrenta tu startup...',
      required: true,
    },
    {
      name: 'modelMarketRisks',
      type: 'textarea',
      label: 'Riesgos del modelo o del mercado.',
      placeholder: 'Describe los riesgos identificados...',
      required: true,
    },
    {
      name: 'scalingBarriers',
      type: 'textarea',
      label: 'Barreras para escalar',
      placeholder: 'Describe las barreras que podrían dificultar el escalamiento...',
      required: false,
    },
  ],
};
